import { Endpoints } from '@brg/api';

const isNotEmpty = (a: any) => {
    return a !== null && a !== undefined && a !== '';
};

export const downloadPDF = (fileUrl: string, cardName: string, error: any, info: any, t: any) => {
    if (isNotEmpty(fileUrl)) {
        const downloadFileUrl = Endpoints.files + '/' + fileUrl;

        fetch(downloadFileUrl, { method: 'GET' })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `${cardName}.pdf`
                document.body.appendChild(a);
                a.click();
                //@ts-ignore
                a = undefined
            })
            .catch((err: any) => {
                console.error('print_error_message', err)
                error(t('card_actions.print_error_message'))
            })
            .finally(() => {
            })
    }
};import { Endpoints } from '@brg/api';

const isNotEmpty = (a: any) => {
    return a !== null && a !== undefined && a !== '';
};

export const downloadPDF = (fileUrl: string, cardName: string, error: any, info: any, t: any) => {
    if (isNotEmpty(fileUrl)) {
        const downloadFileUrl = Endpoints.files + '/' + fileUrl;

        fetch(downloadFileUrl, { method: 'GET' })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `${cardName}.pdf`
                document.body.appendChild(a);
                a.click();
                //@ts-ignore
                a = undefined
            })
            .catch((err: any) => {
                console.error('print_error_message', err)
                error(t('card_actions.print_error_message'))
            })
            .finally(() => {
            })
    }
};